<!--
Author: TangChen
Date: 2019-01-09
Desc: 热门专户理财基金
 -->
<template>
    <div :class="'bizcomp-private-hot bizcomp ' + className">
        <comp-title v-show="false" :title="title" />
        <hot-tab
            v-if="fund.length > 2"
            :private-val="true"
            :fund-info="fund"
            v-on:fund-continue="fundBuy"
        />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import hotTab from "@/components/fund/hotTab";
export default {
    name: "PrivateHot",
    components: {
        hotTab
    },
    mixins: [mixin],
    data() {
        return {
            fund: []
        };
    },
    created() {
        this.getHotFund();
    },
    methods: {
        getHotFund() {
            this.$util.request("pef/trade/recommend").then((res) => {
                if (res.data) {
                    this.fund = res.data;
                }
            });
        },
        fundBuy(way, val) {
            let _url = "";
            if (way === "20,22") {
                _url = "privatebuy";
            }
            val.proto = "buy";
            this.$util.fundRiskCheck(this, val, (res) => {
                if (res) {
                    const _x = Object.assign({}, res, { way: way });
                    sessionStorage.setItem(_url, JSON.stringify(_x));
                    this.$router.push({ name: _url, query: { fundcode: res.fundcode } });
                }
            });
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.bizcomp-private-hot {
    overflow: hidden;
    .comp-fund-list {
        padding: 10px 20px;
        .el-table--fit {
            margin: 0;
        }
    }
}
</style>
